import camelcaseKeys from "camelcase-keys";
import { nanoid } from "nanoid";

import { parseApiError } from "@/utils/parseApiError";

import { createAlertAction } from "../alerts/alerts.actions";
import {
  DRAFT_PURCHASE_ORDER,
  GET_EXTERNAL_PURCHASE_ORDER,
  GET_PURCHASE_ORDER,
  UPDATE_PURCHASE_ORDER,
  UPDATE_PURCHASE_ORDER_SILENTLY,
} from "../purchaseOrders/purchaseOrders.actionTypes";

const tokenInject = (service) => {
  const token = JSON.parse(window.localStorage.getItem("auth"));
  return service()(token);
};

const dispatchApi = async (dispatch, actionName, service, intent) => {
  // Create API actions
  const pendingAction = () => ({
    type: `${actionName}/pending`,
    payload: {},
  });
  const fulfilledAction = (data) => ({
    type: `${actionName}/fulfilled`,
    intent,
    payload: { data },
  });
  const rejectedAction = (data) => ({
    type: `${actionName}/rejected`,
    payload: { data },
  });

  // actions that we want to manually camelCase in the reducer
  const actionNames = [
    DRAFT_PURCHASE_ORDER,
    UPDATE_PURCHASE_ORDER,
    UPDATE_PURCHASE_ORDER_SILENTLY,
    GET_PURCHASE_ORDER,
    GET_EXTERNAL_PURCHASE_ORDER,
  ];

  dispatch(pendingAction());

  try {
    const response = await tokenInject(service);
    const responseData = response?.data;

    if (actionNames.includes(actionName)) {
      dispatch(fulfilledAction(responseData));
      return responseData;
    }

    if (typeof responseData === "string" || !responseData) {
      dispatch(fulfilledAction(responseData));
      return responseData;
    }
    if (responseData instanceof ArrayBuffer) {
      const file = new Blob([responseData], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      dispatch(fulfilledAction(camelcaseKeys(responseData, { deep: true })));
      return responseData;
    }
  } catch (error) {
    console.log("dispatchApi", error);
    dispatch(rejectedAction(error));

    if (error.response) {
      dispatch(createAlertAction(nanoid(), parseApiError(error).message, false, "danger"));
    }
  }
};

export default dispatchApi;
